import { GridCellProps } from "@progress/kendo-react-grid";

export default function HeureCell(gridProps: GridCellProps) {
    const { dataItem } = gridProps;
    const field = gridProps.field || '';
    const dataValue = dataItem[field] === null ? 0 : dataItem[field];

    const getFormattedHeure = () => {
        let formattedDecimal = dataValue.toLocaleString('fr-CA', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

        return formattedDecimal.toString().replace(",", "h");
    };

    return <td>{dataValue ? getFormattedHeure() : 0}</td>;
}